import type { DraftSaveStatus } from "@/hooks/useFormDraftAutosave";
import { useLang } from "@/features/onboarding/i18n";
import { formatDraftTime } from "./draft";

export function DraftSaveIndicator({ status, savedAt }: { status: DraftSaveStatus; savedAt: number | null }) {
  const { t, locale } = useLang();
  const text =
    status === "saving"
      ? t("wiz.saving")
      : status === "failed"
        ? t("wiz.notSaved")
        : status === "saved" && savedAt != null
          ? t("wiz.saved", { time: formatDraftTime(savedAt, locale) })
          : "";
  return (
    <p
      aria-live="polite"
      className={"h-5 text-right text-xs " + (status === "failed" ? "text-amber-600" : "text-slate-400")}
    >
      {text}
    </p>
  );
}
